/**
 *  Redux saga class init
 */
import { takeEvery, all, takeLatest } from 'redux-saga/effects'
import loginSaga, { AllLogoutUserAsync, changePasswordAsync, forgetPassword, logoutUser, resetPassword, updateProfile, updateSmartContractInfo } from './auth'
import { fetchData, initData, pageData, searchData, deleteRowData, addData, updateData, sortData, exportData, importData, pageSize, cellLoading, registrationData } from './table'
import { searchMaterialTypes, searchPartner, searchSharedMaterials, searchTable } from './routes'
import { fetchSteps, addStep, updateStep, deleteStep, publishRoute, requestStepData, updateStepCords, updateRoutePanZoom, resetPartnerPasswordData, deletePartnerRequestData } from './steps'
import { addInfo, deleteInfo, updateInfo } from './product'
import { addDelivery, addProcessing, fetchReceipt } from './trackandtrace'
import { addPassportStep, applyForCertificationData, assetReceiveData, deletePassportStep, doCertifyData, fetchPassport, undoPassportStep, updatePassportPanZoom, updatePassportStep, updatePassportStepCords } from './passport'
import { updateForm302DevRouteSaga, fetchForm302, addForm302Step, deleteForm302RouteStep, updateFomr302RouteStepCords, updateForm302RoutePanZoom, publishForm302Route, fetchCategoriesSaga, updateForm302RouteSaga } from './form302'

export default function* watch() {
    yield takeEvery('INIT_TABLE_DATA_LOAD', initData)
    yield takeEvery('TABLE_DATA_LOAD', fetchData)
    yield takeEvery('TABLE_DATA_SET_PAGE', pageData)
    yield takeEvery('TABLE_DATA_CHANGE_PAGE_SIZE', pageSize)
    yield takeLatest('TABLE_DATA_SEARCH', searchData)
    yield takeLatest('TABLE_DATA_SORT', sortData)
    yield takeLatest('TABLE_ROW_ADD', addData)
    yield takeLatest('TABLE_ROW_UPDATE', updateData)
    yield takeLatest('TABLE_ROW_DELETE', deleteRowData)
    yield all([takeLatest('PARTNER_SEARCH', searchPartner)])
    yield all([takeLatest('MATERIAL_TYPES_SEARCH', searchMaterialTypes)])
    yield all([takeLatest('SHARED_MATERIALS_SEARCH', searchSharedMaterials)])
    yield all([takeLatest('TABLE_AUTOCOMPLETE', searchTable)])
    yield takeEvery('FETCH_STEPS', fetchSteps)
    yield takeEvery('ADD_STEP', addStep)
    yield takeEvery('UPDATE_STEP', updateStep)
    yield takeEvery('UPDATE_STEP_CORDS', updateStepCords)
    yield takeEvery('DELETE_STEP', deleteStep)
    yield takeEvery('LOGIN_REQUEST', loginSaga)
    yield takeEvery('LOGOUT_REQUEST', logoutUser)
    yield takeEvery('LOGOUT_ALL_REQUEST', AllLogoutUserAsync)
    yield takeEvery('PASSWORD_UPDATE', changePasswordAsync)
    yield takeEvery('UPDATE_PROFILE', updateProfile)
    yield takeEvery('ADD_PRODUCT_ROUTE_INFO', addInfo)
    yield takeEvery('UPDATE_PRODUCT_ROUTE_INFO', updateInfo)
    yield takeEvery('DELETE_PRODUCT_ROUTE_INFO', deleteInfo)
    yield takeEvery('LOAD_RECEIPT', fetchReceipt)
    yield takeEvery('PUBLISH_ROUTE', publishRoute)
    yield takeEvery('TABLE_EXPORT', exportData)
    yield takeEvery('TABLE_IMPORT', importData)
    yield takeEvery('REQUEST_STEP_DATA', requestStepData)
    yield takeEvery('FORGET_PASSWORD', forgetPassword)
    yield takeEvery('RESET_PASSWORD', resetPassword)
    yield takeEvery('UPDATE_ROUTE_PAN_ZOOM', updateRoutePanZoom)
    yield takeEvery('RESET_PARTNER_PASSWORD', resetPartnerPasswordData)
    yield takeEvery('DELETE_PARTNER_REQUEST', deletePartnerRequestData)
    yield takeEvery('FETCH_PASSPORT_STEPS', fetchPassport)
    yield takeEvery('ADD_PASSPORT_STEP', addPassportStep)
    yield takeEvery('UPDATE_PASSPORT_STEP', updatePassportStep)
    yield takeEvery('UPDATE_PASSPORT_STEP_CORDS', updatePassportStepCords)
    yield takeEvery('DELETE_PASSPORT_STEP', deletePassportStep)
    yield takeEvery('UPDATE_PASSPORT_PAN_ZOOM', updatePassportPanZoom)
    yield takeEvery('APPLY_STEP_CERTIFICATION', applyForCertificationData)
    yield takeEvery('DO_CERTIFICATION', doCertifyData)
    yield takeEvery('RECEIVE_ASSET', assetReceiveData)
    yield takeEvery('CELL_LOADING', cellLoading)
    yield takeEvery('TABLE_ROW_REGISTER', registrationData)
    yield takeEvery('UPDATE_SMART_CONTRACT', updateSmartContractInfo)
    yield takeEvery('UNDO_PASSPORT_STEP', undoPassportStep)
    yield takeEvery('FETCH_FORM302_STEPS', fetchForm302)
    yield takeEvery('ADD_FORM302_STEP', addForm302Step)
    yield takeEvery('DELETE_FORM302_ROUTE_STEP', deleteForm302RouteStep)
    yield takeEvery('UPDATE_FORM302_STEP_CORDS', updateFomr302RouteStepCords)
    yield takeEvery('UPDATE_FORM302_PAN_ZOOM', updateForm302RoutePanZoom)
    yield takeEvery('PUBLISH_FORM302_ROUTE', publishForm302Route)
    yield takeEvery('FETCH_CATEGORIES', fetchCategoriesSaga)
    yield takeEvery('UPDATE_FORM302_ROUTE', updateForm302RouteSaga)
    yield takeEvery('UPDATE_FORM302_DEV_ROUTE', updateForm302DevRouteSaga)
}
